/* @flow */

import * as React from 'react';

import type {
  UseQuery,
  ApiListResult,
} from 'src/shared/app/base/api/type/apiQueryType';
import FeedQueryPageItem from 'src/shared/ui/component/data-display/FeedQueryPageItem';

type Props<T> = {
  useQuery: UseQuery<ApiListResult<T>>,
  renderItem: (T) => React.Node,
  params: Object,
  page: number,
  isCompact?: boolean,
  interstitialComponents?: Array<React.Node>,
  interstitialIndexes?: Array<number>,
};

function FeedQueryPage<T>({
  useQuery,
  renderItem,
  params,
  page,
  isCompact,
  interstitialComponents,
  interstitialIndexes,
}: Props<T>): React.Node {
  const { data } = useQuery({ ...params, page });

  return (
    <>
      {data?.results.map((item, index) => (
        <FeedQueryPageItem
          item={item}
          index={index}
          key={index}
          interstitialComponents={interstitialComponents}
          interstitialIndexes={interstitialIndexes}
          isCompact={isCompact}
          page={page}
          renderItem={renderItem}
        />
      ))}
    </>
  );
}

export default FeedQueryPage;
